import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

// 获取记录信息
export const getOrderList = async (params: object) => {
  return await POST({
    url: Api.getOrderList,
    data: params,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}
